import { IonButton } from "@ionic/react";
import { mapOutline } from "ionicons/icons";
import React from "react";
import IDXButtonIcon from "../IDXButtonIcon/IDXButtonIcon";

interface ContainerProps {
    location: string;
    handleTrickLocationClick: (location: string) => void;
}

const TrickMapLocation: React.FC<ContainerProps> = (props: ContainerProps) => {
    return (
        <>
            {
                props.location ?
                    <IonButton fill="clear" size="small" color="dark" onClick={() => props.handleTrickLocationClick(props.location)}>
                        <IDXButtonIcon size="text-2xl" icon={mapOutline} />
                    </IonButton> : null
            }
        </>
    );
};

export default TrickMapLocation;
